import { render } from "./public_sell_details.vue?vue&type=template&id=fc0c1b26"
import script from "./public_sell_details.vue?vue&type=script&lang=js"
export * from "./public_sell_details.vue?vue&type=script&lang=js"

import "./public_sell_details.vue?vue&type=style&index=0&id=fc0c1b26&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__